"use client";

import { PrismicRichText } from "@prismicio/react";

import { Disclosure } from "../disclosure/disclosure";

import type { KeyTextField, LinkField, RichTextField } from "@prismicio/client";
import type { ComponentType } from "react";

/**
 * CSS is required for `.accordion-button` and `.accordion-panel`
 * Animation uses `grid-template-rows` transition on `.accordion-panel`.
 */
export function Accordion({
  CTA,
  richTextComponents,
  slice,
}: {
  CTA: ComponentType<any>;
  richTextComponents: any;
  slice: {
    primary: {
      theme: string;
    };
    items: Array<{
      body: RichTextField;
      cta_classes?: KeyTextField;
      cta_link?: LinkField;
      cta_text?: KeyTextField;
      cta_variant?: string;
      heading: KeyTextField;
    }>;
  };
}) {
  return (
    <>
      {slice.items.map((item, index) => {
        return (
          <div key={index}>
            <Disclosure>
              {({ buttonProps, open, panelProps, toggle }) => (
                <>
                  <button
                    className="accordion-button"
                    type="button"
                    onClick={() => toggle()}
                    {...buttonProps}
                  >
                    {item.heading}
                  </button>

                  <div
                    className="accordion-panel"
                    data-expanded={open}
                    {...panelProps}
                  >
                    <div className="accordion-panel-content">
                      <PrismicRichText
                        components={richTextComponents(slice.primary.theme)}
                        field={item.body}
                      />

                      {item.cta_text && (
                        <>
                          <br />
                          <CTA
                            className={item.cta_classes}
                            field={item.cta_link}
                            variant={item.cta_variant}
                          >
                            {item.cta_text}
                          </CTA>
                          <br />
                        </>
                      )}
                      <br />
                    </div>
                  </div>
                </>
              )}
            </Disclosure>
          </div>
        );
      })}
    </>
  );
}
